import { z } from "zod";
export const dmaCalculationMetadataInitialGuessesDtoSchema = z.discriminatedUnion("source", [
    z.object({
        source: z.literal("None"),
    }),
    z.object({
        source: z.literal("Hint"),
    }),
    z.object({
        source: z.literal("Database"),
        databaseId: z.number(),
    }),
]);
